import React from 'react';
import GroupForm from './GroupForm';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import { useGroupState, useGroupActions } from './GroupContext';

const GroupModal = () => {
  const state = useGroupState();
  const { closeGroupModal } = useGroupActions();

  return (
    <StandardModal
      isOpen={state?.groupModalIsOpen}
      onRequestClose={() => {
        closeGroupModal();
      }}
    >
      <GroupForm />
    </StandardModal>
  );
};

export default GroupModal;
